import { useTranslation, Trans } from "react-i18next"
import logo_uwe0 from '../../assets/images/logos/logo_uwe.jpg';
import logo_agoria1 from '../../assets/images/logos/logo_agoria.jpg';
import logo_wallonie_entreprendre2 from '../../assets/images/logos/logo_wallonie_entreprendre.png';
import logo_awex3 from '../../assets/images/logos/logo_awex.png';
import logo_bep4 from '../../assets/images/logos/logo_bep.png';
import logo_cap_innove5 from '../../assets/images/logos/logo_cap_innove.png';
import logo_cci_lvn6 from '../../assets/images/logos/logo_cci_lvn.png';
import logo_cei_louvain7 from '../../assets/images/logos/logo_cei_louvain.png';
import logo_charleroi_entreprendre8 from '../../assets/images/logos/logo_charleroi_entreprendre.png';
import logo_eklo9 from '../../assets/images/logos/logo_eklo.png';
import logo_embuild10 from '../../assets/images/logos/logo_embuild.png';
import logo_entreprendre_wapi11 from '../../assets/images/logos/logo_entreprendre_wapi.png';
import logo_greenwin12 from '../../assets/images/logos/logo_greenwin.png';
import logo_hec_digital_lab13 from '../../assets/images/logos/logo_hec_digital_lab.png';
import logo_idea14 from '../../assets/images/logos/logo_idea.png';
import logo_idelux15 from '../../assets/images/logos/logo_idelux.png';
import logo_infopole16 from '../../assets/images/logos/logo_infopole.png';
import logo_mic18 from '../../assets/images/logos/logo_mic.png';
import logo_ucm19 from '../../assets/images/logos/logo_ucm.png';
import logo_wfg_ostbelgien20 from '../../assets/images/logos/logo_wfg_ostbelgien.png';
import logo_spw_eer21 from '../../assets/images/logos/logo_spw_eer.png';
import logo_digiscore from '../../assets/images/svg/digiscore.svg';
import './Home.css';
import LanguageSwitcher from "../../components/LanguageSwitcher/LanguageSwitcher";
import Link from "../../components/Link/Link";
import useWindowSize from "../../hook/useWindowSize";
import MenuIcon from "../../assets/images/svg/menu.svg";
import CloseIcon from "../../assets/images/svg/icon-close.svg";
import { useState } from "react";
import Video from "../../components/Video/Video";
import Marquee from "../../components/Marquee/Marquee";

const logos = [
  { src: logo_uwe0, alt: 'UWE', link: 'https://www.uwe.be' },
  { src: logo_agoria1, alt: 'Agoria', link: 'https://www.agoria.be' },
  { src: logo_wallonie_entreprendre2, alt: 'Wallonie entreprendre', link: 'https://www.wallonie-entreprendre.be/' },
  { src: logo_awex3, alt: 'AWEX', link: 'https://www.awex.be/' },
  { src: logo_bep4, alt: 'BEP', link: 'https://www.bep.be/' },
  { src: logo_cap_innove5, alt: 'Cap Innove', link: 'https://www.capinnove.be/' },
  { src: logo_cci_lvn6, alt: 'CCI LVN', link: 'https://www.ccilvn.be/' },
  { src: logo_cei_louvain7, alt: 'CEI Louvain', link: 'https://www.facebook.com/CEEILouvain/' },
  { src: logo_charleroi_entreprendre8, alt: 'Charleroi Entreprendre', link: 'https://charleroi-entreprendre.be/' },
  { src: logo_eklo9, alt: 'EKLO', link: 'https://eklo.be/' },
  { src: logo_embuild10, alt: 'Embuild', link: 'https://wallonie.embuild.be/fr' },
  { src: logo_entreprendre_wapi11, alt: 'Entreprendre Wapi', link: 'https://www.entreprendrewapi.be/' },
  { src: logo_greenwin12, alt: 'Greenwin', link: 'https://www.greenwin.be/fr/' },
  { src: logo_hec_digital_lab13, alt: 'HEC Digital Lab', link: 'https://www.digitallab.be/fr/' },
  { src: logo_idea14, alt: 'IDEA', link: 'https://www.idea.be/' },
  { src: logo_idelux15, alt: 'Idelux', link: 'https://www.idelux.be/' },
  { src: logo_infopole16, alt: 'Infopole', link: 'https://clusters.wallonie.be/infopole/fr' },
  { src: logo_mic18, alt: 'MIC', link: 'https://www.mic-belgique.be/' },
  { src: logo_ucm19, alt: 'UCM', link: 'https://www.ucm.be/' },
  { src: logo_wfg_ostbelgien20, alt: 'WFG Ostbelgien', link: 'https://www.wfg.be/fr/home-2/' },
  { src: logo_spw_eer21, alt: 'SPW EER', link: 'https://www.wallonie.be/fr/acteurs-et-institutions/wallonie/service-public-de-wallonie/spw-economie-emploi-recherche' },
];

function renderMenu(item) {
  switch (item.type) {
    case 'anchor':
      return (
        <a href={`#${item.link}`}>{item.text}</a>
      );
    case 'button':
      return (
        <Link text={item.text} href={item.link} />
      );
    default:
      return null;
  }
}

export default function Home() {
  const { t } = useTranslation();

  const [isMenuOpen, setMenuOpen] = useState(false);
  const windowSize = useWindowSize();

  const menuItems = t('menu', { returnObjects: true });

  return (
    <div className="home">
      <div className="intro">
        <div className={`header ${isMenuOpen ? 'menu-open' : ''}`}>
          <div></div>
          <div className="header-logo">
            <img alt="" src={logo_digiscore} />
          </div>
          {windowSize.width >= 640 ? (
            <div className="switcher">
              <LanguageSwitcher />
            </div>
          ) : (
            <div className="burger-menu" onClick={() => setMenuOpen(!isMenuOpen)}>
              <img alt="" src={isMenuOpen ? CloseIcon : MenuIcon} />
            </div>
          )}
        </div>
        {windowSize.width < 640 ? (
          <div>
            <nav className={`navigation-wrapper ${isMenuOpen ? 'menu-open' : ''}`}>
              <div className="header-logo">
                <img alt="" src={logo_digiscore} />
              </div>
              <ul>
                {menuItems.map((item, i) => (
                  <li key={i} onClick={() => setMenuOpen(false)}>
                    {renderMenu(item)}
                  </li>
                ))}
              </ul>
            </nav>
          </div>
        ) : undefined}
        <div className={`header-visual-wrapper`}>
          <video autoPlay loop muted playsInline className="header-visual">
            <source src={`${window.location.origin}/videos/0001-0299.webm`} />
          </video>
          <div className="intro-wrapper">
            <div className="intro-title-wrapper">
              <h1 className="title">{t('home.intro.title')}</h1>
            </div>
            <div className="intro-text-wrapper">
              <Trans i18nKey="home.intro.p0" />
            </div>
            <div className="intro-link-wrapper">
              <Link
                text={t('home.intro.button')}
                href={'/survey'}
              />
            </div>
          </div>
        </div>
      </div>
      {windowSize.width >= 640 && (
        <nav className="navigation-wrapper">
          <ul>
            {menuItems.map((item, i) => (
              <li key={i}>{renderMenu(item)}</li>
            ))}
          </ul>
        </nav>
      )}
      <div className="content">
        <section id={t('menu.0.link')} className="about-section">
          <h2>{t('menu.0.text')}</h2>
          <div className="section-content">
            <Trans i18nKey="home.intro.p001" />
            <br /><br />
            <ul className="about-list">
              <li><Trans i18nKey="home.intro.li0" /></li>
              <li><Trans i18nKey="home.intro.li1" /></li>
              <li><Trans i18nKey="home.intro.li2" /></li>
            </ul>
          </div>
          <br />
          <Trans i18nKey="home.intro.p002" />
          <br /><br />
          <div className="how-video-wrapper">
            <Video
              videoId="8zi3a7AFnIc"
              background={`${window.location.origin}/images/video-background.png`}
              watchText={t('home.how.watch-text')}
            />
          </div>
        </section>

        <section id={t(`menu.1.link`)}>
          <div className="barometer-section">
            <div className="background-visual">
              {windowSize.width > 640 && <img alt="" src={`${window.location.origin}/images/home-page-background-visual-1.webp`} />}
            </div>
            <h2>{t('menu.1.text')}</h2>
            <div className="section-content">
              <Trans
                i18nKey="home.why.p003"
                components={{
                  p: <p />,
                  ul: <ul className="about-list" />,
                  li: <li />,
                  strong: <strong />
                }}
              />
            </div>
          </div>
        </section>

        <section id={t('menu.2.link')} className="about-section">
          <h2>{t('menu.2.text')}</h2>
          <br /><br />
          <Trans
            i18nKey="home.who.p004"
            components={{
              p: <p />,
              ul: <ul className="about-list" />,
              li: <li />,
              strong: <strong />
            }}
          />
        </section>

        <section id={t('menu.3.link')}>
          <div className="why-section">
            <div className="why-title">
              <h2>{t('home.why.title')}</h2>
            </div>
            <div className="why-content">
              <Trans
                i18nKey="home.why.p005"
                components={{
                  p: <p />,
                  ul: <ul className="about-list" />,
                  li: <li />,
                  strong: <strong />
                }}
              />
            </div>
          </div>
        </section>

        <section id={t('menu.4.link')}>
          <div className="">
            <div className="why-title">
              <h2>{t('home.result.title')}</h2>
            </div>
            <br /><br />
            <div className="why-content">
              <Trans
                i18nKey="home.result.p006"
                components={{
                  p: <p />,
                  ul: <ul className="about-list" />,
                  li: <li />,
                  strong: <strong />
                }}
              />
            </div>
          </div>
        </section>

        <section id={t('menu.5.link')}>
          <div className="">
            <div className="why-title">
              <h2>{t('home.barometer.title')}</h2>
            </div>
            <br /><br />
            <div className="why-content">
              <Trans
                i18nKey="home.barometer.p007"
                components={{
                  p: <p />,
                  ul: <ul className="about-list" />,
                  li: <li />,
                  strong: <strong />
                }}
              />
            </div>
            <br />
            <div className="intro-link-wrapper">
              <a href="https://www.digitalwallonia.be/entreprises2025/" target="_blank" rel="noreferrer" className="link ">Vers le baromètre 2025</a>
            </div>
          </div>
        </section>

        <div className="axis-grid">
          <div className="axis-grid-item">
            <h3 className="axis-grid-item-title">{t('home.companySurvey.item0-title')}</h3>
            <p className="axis-grid-item-content">{t('home.companySurvey.item0-content')}</p>
          </div>
          <div className="axis-grid-item">
            <h3 className="axis-grid-item-title">{t('home.companySurvey.item1-title')}</h3>
            <p className="axis-grid-item-content">{t('home.companySurvey.item1-content')}</p>
          </div>
          <div className="axis-grid-item">
            <h3 className="axis-grid-item-title">{t('home.companySurvey.item2-title')}</h3>
            <p className="axis-grid-item-content">{t('home.companySurvey.item2-content')}</p>
          </div>
          <div className="axis-grid-item">
            <h3 className="axis-grid-item-title">{t('home.companySurvey.item3-title')}</h3>
            <p className="axis-grid-item-content">{t('home.companySurvey.item3-content')}</p>
          </div>
        </div>

        <div className="cta-barometer">
          <img alt="" className="icon-blog" src={`${window.location.origin}/images/icon-blog-red.png`} />
          <p>{t('home.companySurvey.p2strong')} {t('home.companySurvey.p2')}</p>
          <p>{t('home.companySurvey.p3')}</p>
          <br />
          <a href="https://www.digitalwallonia.be/entreprises2025/" className="link" target="_blank" rel="noreferrer">
            Vers le baromètre 2025
          </a>
        </div>

        <section id={t('menu.6.link')}>
          <div className="title-block">
            <div className="partner-icon icon">
              <img src={`${window.location.origin}/images/partner.png`} alt="Partenaire" />
            </div>
            <div className="partner-title">
              <h2>{t('home.partners.title')}</h2>
            </div>
            <div className="partner-marquee-block">
              <Marquee
                items={logos.slice(0, logos.length / 2)}
                direction="ltr"
              />
              <Marquee
                items={logos.slice(logos.length / 2)}
                direction="rtl"
              />
            </div>
          </div>
        </section>

        <section id={t('menu.7.link')}>
          <div className="title-block">
            <div className="partner-icon icon">
              <img src={`${window.location.origin}/images/use-of-data.png`} alt="Data" />
            </div>
            <div className="useofdata-title">
              <h2>{t('home.useofdata.title')}</h2>
            </div>
            <div className="useofdata-content-block">
              <p>{t('home.useofdata.p0')}</p>
              <p>{t('home.useofdata.p1')}</p>
              <p>{t('home.useofdata.p2')}</p>
              <p>{t('home.useofdata.p3')}</p>
              <Link
                text={t('home.useofdata.linkText')}
                href={t('home.useofdata.p3a')}
                transparent={true}
              />
            </div>
          </div>
        </section>
      </div>
    </div>
  )
}